export enum SwapType {
  MARKET,
  TWAP,
  LIMIT,
}
